import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const resendEmailCodeApi = createAsyncThunk(
    'users/resend_email',
    async (account: any, { rejectWithValue }) => {

        const resendURL = `${URL_API}/supplier-portal/resend-verification/${account.id}`;
        let payload: any = {}
        if(account.email){
            payload = {
                type: 'email',
                email: account.email,
            }
        }else{
            payload = {
                type: 'email',
            }
        }
        // A profile change sends the current password so a wrong one is refused
        // before the code is sent (agency-portal#1532).
        if (account.oldPassword) {
            payload.oldPassword = account.oldPassword;
        }

        try {
            const { data } = await axios.post<ResetResult>(resendURL, payload, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
              });

            return data;
        } catch (error) {
            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);